<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <!-- <b-form-group label-cols="3" label="Placeholder">
        <b-form-input @change="changeProp" v-model="field.params.placeholder"/>
      </b-form-group> -->
    <b-form-group label-cols="3" label="Tooltip">
      <b-form-input @change="changeProp" v-model="field.params.tooltip" />
    </b-form-group>
    <b-form-group label-cols="3">
      <b-form-checkbox @input="changeProp" v-model="field.params.multiple"
        >Allow Multiple</b-form-checkbox
      >
    </b-form-group>
    <b-form-group label-cols="3">
      <b-form-checkbox @input="changeProp" v-model="field.params.photos"
        >Photo's Only</b-form-checkbox
      >
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "FileuploadProps",
  components: { WidgetCommonProps },
  mixins: [WidgetPropMixin],
};
</script>
